<template>
 <router-view name="header"/>
    <router-view/>  
    <router-view name="footer"/>
</template>

<script>


import { useI18n } from "vue-i18n";

export default {
  name: "Banner",
  components: {
  
  },
  setup() {
    const { t } = useI18n();
    
    return {
      t
    };
  },
  methods: {
    scrollToNextSection() {
      // 向下滚动到下一个部分
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth"
      });
    }
  },
  mounted() {
    // 确保视频在移动设备上可以自动播放
    const video = this.$refs.bannerVideo;
    if (video) {
      // 在某些移动设备上需要用户交互后才能播放
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log("视频自动播放被阻止:", error);
        });
      }
    }
  }
}
</script>

<style scoped>
.banner-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.banner-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.banner-video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%);
  object-fit: cover;
  z-index: -1;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.banner-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  z-index: 2;
  padding: 0 20px;
}

.text-content {
  max-width: 900px;
  margin-bottom: 60px;
}

.main-title {
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1.3;
  margin-bottom: 20px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.sub-title {
  font-size: 1.5rem;
  font-weight: normal;
  line-height: 1.5;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.scroll-down-icon {
  position: absolute;
  bottom: 40px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  animation: bounce 2s infinite;
  z-index: 3;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-title {
    font-size: 1.8rem;
  }
  
  .sub-title {
    font-size: 1.2rem;
  }
  
  .text-content {
    margin-bottom: 40px;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 1.5rem;
  }
  
  .sub-title {
    font-size: 1rem;
  }
}
</style>